import { AhPlusPricingPlans } from "modules/storyblok/components";
import type { AhPlusPricingPlansProps } from "modules/storyblok/components/AhPlusPricingPlans";
import type { ReactStoryblokComponent } from "types/storyblok";
import ExperimentAhPlusPricingPlans from "modules/experiments/AhPlusPricingPlans";
import { Flex, Spinner } from "@chakra-ui/react";

import { useOptimizely } from "hooks/useOptimizely";

const AhPlusPricingPlansAdapter = ({
  blok: {
    bottomText,
    cards,
    horizontalPaddingDesktop,
    horizontalPaddingMobile,
    verticalPaddingDesktop,
    verticalPaddingMobile,
  },
}: ReactStoryblokComponent<AhPlusPricingPlansProps>) => {

  const { variation, isLoading: isExperimentLoading, pushConversionEvent } = useOptimizely({
    experimentName: "AhPlus Pricing Plans - Monthly values",
    experimentId: 25422480499,
    variations: {
      25456560024: 0, // original variant
      25420050413: 1,
    },
    pages: [
      { language: "en", slug: "airhelp-plus" },
      { language: "en-gb", slug: "airhelp-plus" },
      { language: "en-ie", slug: "airhelp-plus" },
      { language: "en-ca", slug: "airhelp-plus" },
      { language: "en-int", slug: "airhelp-plus" },
    ],
    customEvent: {
      type: "event",
      eventName: "choose_membership_plan"
    },
  });

  if (isExperimentLoading) {
    return (
      <Flex background="primary.900" height="740px" width="100%" alignItems="center" justifyContent="center">
        <Spinner />
      </Flex>
    );
  }

  return variation === 1 ? (
    <ExperimentAhPlusPricingPlans pushConversionEvent={pushConversionEvent} />
  ) : (
    <AhPlusPricingPlans
      horizontalPaddingMobile={horizontalPaddingMobile}
      horizontalPaddingDesktop={horizontalPaddingDesktop}
      verticalPaddingDesktop={verticalPaddingDesktop}
      verticalPaddingMobile={verticalPaddingMobile}
      bottomText={bottomText}
      cards={cards}
    />
  )};


export default AhPlusPricingPlansAdapter;
